import { render, staticRenderFns } from "./EmailMessageActions.vue?vue&type=template&id=49b7c85e&scoped=true&"
import script from "./EmailMessageActions.vue?vue&type=script&lang=js&"
export * from "./EmailMessageActions.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageActions.vue?vue&type=style&index=0&id=49b7c85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b7c85e",
  null
  
)

export default component.exports